import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-x",
  "use": "icon-x-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-x\"><g clip-path=\"url(#icon-x_a)\"><path d=\"M11.55 8.224 18.775 0h-1.712l-6.276 7.14L5.78 0H0l7.576 10.797L0 19.42h1.711l6.624-7.54 5.29 7.54h5.78M2.328 1.264h2.63l12.103 16.954h-2.63\" fill=\"currentColor\" /></g><defs><clipPath id=\"icon-x_a\"><path fill=\"#fff\" d=\"M0 0h19.404v19.42H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol